// extracted by mini-css-extract-plugin
export default {"login":"Login_login__dcF7k","inviteCode":"Login_inviteCode__Uh2Qr","code":"Login_code__qUMR7","magicLogin":"Login_magicLogin__gNmZj","error":"Login_error__6iUM9"};